import { render, staticRenderFns } from "./TestBookTable.vue?vue&type=template&id=5a046b95"
import script from "./TestBookTable.vue?vue&type=script&lang=js"
export * from "./TestBookTable.vue?vue&type=script&lang=js"
import style0 from "./TestBookTable.vue?vue&type=style&index=0&id=5a046b95&prod&lang=css"
import style1 from "./TestBookTable.vue?vue&type=style&index=1&id=5a046b95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports